var _defs, _use, _use2, _path, _use3, _use4, _use5, _use6, _use7, _use8, _path2, _use9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinoculars389Fc56A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M51.92 76.2c0 1.19.14 2.37.4 3.52 2.75-6.59 9.84-11.28 18.15-11.28 9.35 0 17.16 5.93 18.97 13.82.8-1.92 1.21-3.98 1.21-6.06 0-9.57-8.67-17.33-19.36-17.33-10.7 0-19.37 7.76-19.37 17.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M87.17 33.46a9.05 9.05 0 0 0-7.93 8.96l.01.46h-.01l.54 9.42 6.4-1.05c2.33.55 4.79.15 6.82-1.12l7.39-1.2-3.4-8.69a8.98 8.98 0 0 0-9.83-6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M90.06 45.77a16.76 16.76 0 0 0-14.22 16.6c0 .5.02 1 .06 1.47l-.06.02 2.11 23.5a19.75 19.75 0 0 0 21.32 19.35 19.8 19.8 0 0 0 18.13-19.75 19.86 19.86 0 0 0-2-8.72l-6.92-20.77a16.64 16.64 0 0 0-18.42-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M32.8 57.47l-7.23 20.76a19.6 19.6 0 0 0-1.53 4.42 19.94 19.94 0 0 0 6.14 19.24 19.63 19.63 0 0 0 19.72 3.85A19.83 19.83 0 0 0 62.75 90.2v-.02c.13-.77.2-1.54.24-2.32l2.45-24-.06-.02a16.76 16.76 0 0 0-14.16-18.07 16.7 16.7 0 0 0-18.42 11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M23.56 87.65c0 10.58 8.86 19.17 19.79 19.17s19.79-8.59 19.79-19.17c0-10.6-8.86-19.18-19.8-19.18-10.92 0-19.78 8.59-19.78 19.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M77.82 87.65c0 10.58 8.86 19.17 19.79 19.17s19.79-8.59 19.79-19.17c0-10.6-8.86-19.18-19.79-19.18s-19.79 8.59-19.79 19.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M84.75 87.65c0 6.88 5.76 12.46 12.86 12.46s12.86-5.58 12.86-12.46c0-6.89-5.76-12.47-12.86-12.47s-12.86 5.58-12.86 12.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M97.61 75.18c-7.1 0-12.86 5.58-12.86 12.47 0 3.28 1.33 6.43 3.68 8.72l17.83-17.95a13.04 13.04 0 0 0-8.6-3.24h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M43.35 75.18c-7.1 0-12.87 5.58-12.87 12.47a12.27 12.27 0 0 0 3.68 8.72L52 78.42a13.04 13.04 0 0 0-8.6-3.24h-.04z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#D17511",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#FFB048",
    xlinkHref: "#b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB048",
    d: "M61.66 42.42a9.02 9.02 0 0 0-17.77-2.18l-3.38 8.69 7.38 1.2a8.96 8.96 0 0 0 6.83 1.12l6.4 1.05.54-9.42v-.46"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#F90",
    xlinkHref: "#c"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "#F90",
    xlinkHref: "#d"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "#D17511",
    xlinkHref: "#e"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "#D17511",
    xlinkHref: "#f"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    fill: "#F5F5F5",
    xlinkHref: "#g"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    fill: "#C9C9C9",
    xlinkHref: "#h"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M43.35 100.1c7.1 0 12.86-5.57 12.86-12.45 0-6.89-5.76-12.47-12.86-12.47s-12.86 5.58-12.86 12.47c0 6.88 5.75 12.46 12.86 12.46"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    fill: "#C9C9C9",
    xlinkHref: "#i"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars389Fc56A);
export default __webpack_public_path__ + "static/media/binoculars.389fc56a.389fc56a21d93855e9ea5095bab1b727.svg";
export { ForwardRef as ReactComponent };